import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { redirectToPortalPath } from '../../utils/access-redirect';

@Component({
  selector: 'portal-external-redirect',
  template: '',
})
export class PortalExternalRedirectComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const data = this.route.snapshot.data || {};
    let portalPath = data.portalPath || '/dashboard/parcerias-exclusivas';

    if (data.useIdQuery) {
      const id = this.route.snapshot.paramMap.get('id');
      if (id) {
        portalPath = `${portalPath}?id=${encodeURIComponent(id)}`;
      }
    }

    redirectToPortalPath(portalPath);
  }
}
